import PropTypes from 'prop-types';

import { Checkbox } from '@utilities';

import { SOURCE_CATEGORY_ORDER } from '../../utilities/constants';

import styles from './_index.module.scss';

/**
 * Left rail: the banner cuts available to add, grouped under fixed category
 * headers mirroring the standard global-filters dropdown.
 */
const SourceRail = ({ onToggleSource, selectedSourceIds, sources }) => (
  <div className={styles['source-rail']}>
    <h4>Banner Columns</h4>
    {SOURCE_CATEGORY_ORDER.map(({ id: categoryId, label: categoryLabel }) => {
      const categorySources = sources.filter(({ category }) => category === categoryId);
      if (!categorySources.length) return null;

      return (
        <div className={styles['source-rail-section']} key={categoryId}>
          <h5>{categoryLabel}</h5>
          <ul>
            {categorySources.map((source) => (
              <li key={source.id}>
                <Checkbox
                  id={`crosstab-source-${source.id}`}
                  isChecked={selectedSourceIds.includes(source.id)}
                  label={<div className={styles['source-rail-label']}>{source.label}</div>}
                  onChange={() => onToggleSource(source)}
                  title={source.label}
                  value={source.id}
                />
              </li>
            ))}
          </ul>
        </div>
      );
    })}
  </div>
);

SourceRail.propTypes = {
  onToggleSource: PropTypes.func.isRequired,
  selectedSourceIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  sources: PropTypes.arrayOf(
    PropTypes.shape({
      category: PropTypes.string.isRequired,
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default SourceRail;
